// extracted by mini-css-extract-plugin
module.exports = {"Canvas":"Canvas_Canvas__3mP1t","CanvasCard":"Canvas_CanvasCard__EeCu1","CanvasCardInfoDiv":"Canvas_CanvasCardInfoDiv__37Ft0"};